import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

const TestQRPage = () => {
  const { eventId } = useParams();
  const [manualCode, setManualCode] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const API = process.env.REACT_APP_BACKEND_URL + '/api';

  const testCheckIn = async (memberId) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('wclub_admin_token');
      const response = await fetch(`${API}/events/${eventId}/checkin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ member_id: memberId })
      });
      const data = await response.json();
      setResult(data);
    } catch (err) {
      setResult({ error: err.message });
    }
    setLoading(false);
  };

  const handleManualSubmit = () => {
    // Parse QR code data
    let memberId = manualCode;
    if (manualCode.startsWith('WCLUB:')) {
      memberId = manualCode.replace('WCLUB:', '');
    } else if (manualCode.startsWith('WCLUB-')) {
      memberId = manualCode.replace('WCLUB-', '');
    }
    testCheckIn(memberId);
  };

  // Test members
  const testMembers = [
    { id: '82fdcfab', name: 'Tarciso Winners' },
    { id: '303d99c8', name: 'Lelo' },
  ];

  return (
    <div className="min-h-screen bg-[#0a0a0c] p-4">
      <h1 className="text-white text-xl mb-4">Teste de QR Code - Check-in</h1>
      <p className="text-white/50 text-sm mb-6">Event ID: {eventId}</p>

      {/* QR Codes para teste */}
      <div className="mb-8">
        <h2 className="text-white/70 text-sm mb-3">QR Codes dos Membros:</h2>
        <div className="flex gap-4 flex-wrap">
          {testMembers.map(m => (
            <div key={m.id} className="bg-white p-3 rounded-lg text-center">
              <img 
                src={`https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=WCLUB:${m.id}&margin=0&format=png`}
                alt={m.name}
                className="w-32 h-32"
              />
              <p className="text-black text-xs mt-2 font-bold">{m.name}</p>
              <p className="text-gray-500 text-[10px]">WCLUB:{m.id}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Teste manual */}
      <div className="mb-6">
        <h2 className="text-white/70 text-sm mb-3">Teste Manual:</h2>
        <input
          type="text"
          value={manualCode}
          onChange={(e) => setManualCode(e.target.value)}
          placeholder="Cole o código aqui (ex: WCLUB:82fdcfab)"
          className="w-full p-3 bg-white/10 border border-white/20 rounded-lg text-white mb-2"
        />
        <button
          onClick={handleManualSubmit}
          disabled={loading || !manualCode}
          className="w-full py-3 bg-green-500/20 border border-green-500/30 rounded-lg text-green-400 disabled:opacity-50"
        >
          {loading ? 'Testando...' : 'Testar Check-in'}
        </button>
      </div>

      {/* Botões de teste rápido */}
      <div className="mb-6">
        <h2 className="text-white/70 text-sm mb-3">Teste Rápido:</h2>
        <div className="space-y-2">
          {testMembers.map(m => (
            <button
              key={m.id}
              onClick={() => testCheckIn(m.id)}
              disabled={loading}
              className="w-full py-3 bg-blue-500/20 border border-blue-500/30 rounded-lg text-blue-400 disabled:opacity-50"
            >
              Check-in {m.name} ({m.id})
            </button>
          ))}
        </div>
      </div>

      {/* Resultado */}
      {result && (
        <div className={`p-4 rounded-lg ${result.error || result.detail ? 'bg-red-500/20 border border-red-500/30' : 'bg-green-500/20 border border-green-500/30'}`}>
          <pre className="text-white text-xs overflow-auto">
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default TestQRPage;
